import { css } from '@emotion/react';
import * as React from 'react';

interface GridItemWrapperProp {
  span?: number;
}

export const GridItemWrapper: React.FC<React.PropsWithChildren<GridItemWrapperProp>> = ({
  span,
  children,
}) => {
  return <div css={styles.wrapperStyles(span)}>{children}</div>;
};

const styles = {
  wrapperStyles: (span?: number) =>
    css({
      gridColumnStart: 'auto',
      gridColumnEnd: `span ${span ? span : '12'}`,
    }),
};
